import { render, staticRenderFns } from "./TrainingBenefitCallout.vue?vue&type=template&id=0555ffbe&"
import script from "./TrainingBenefitCallout.vue?vue&type=script&lang=js&"
export * from "./TrainingBenefitCallout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports